import { connect } from "react-redux";

import { post } from "../../../../../../../actions/general";
import { editTask, clearTask } from "../../../../../../../store/plan/actions";

import Upload from "./Upload";

export default connect(null, { post, editTask, clearTask })(Upload);
